import debugLib from 'debug'
import { getCookie } from './cookieHelpers'

const debug = debugLib('Analytics')

export function updateDigitalData (userInfo, reason) {
  let ANALYTICS_DATA_OBJECT = window.digitalData

  if (userInfo) {
    const loginStatus = userInfo.userState === 'GUEST' ? 'Non-Registered' : userInfo.userState === 'RECOGNISED' ? 'Recognised' : 'Registered'
    ANALYTICS_DATA_OBJECT.user[0].profile = [Object.assign({}, window.digitalData.user[0].profile, {
      profileInfo: {
        profileID: userInfo.userId
      },
      attributes: {
        globalView: document.cookie.indexOf('PostCodeSessionCookie') < 0 || getCookie('PostCodeSessionCookie') === '%2C%2C',
        loginStatus: loginStatus
      }
    })]
  }

  debug(`DigitalData object updated due to ${reason}`, window.digitalData)
}

export function getPageHeadAnalytics () {
  const initialDataObject = {
    page: { pageInfo: {}, attributes: {} },
    user: [{ profile: [{ attributes: { loginStatus: 'Non-Registered' }, profileInfo: { profileID: '' } }] }],
    appWebView: false
  }

  initialDataObject.page.pageInfo.pageName = 'ar:help:'
  initialDataObject.page.pageInfo.siteSection = 'ar:help:'
  initialDataObject.page.attributes.globalView = 'true'
  initialDataObject.page.attributes.platform = 'react_help'

  let script = `var getCookie = ${getCookie.toString()};var is_from_mcomm = document.referrer.indexOf('argos.co.uk/m/') > -1`
  let setChannelValue = `getCookie('analytics_channel') === 'mcomm' || is_from_mcomm ? 'uk:mobile' : 'uk:desktop'`
  return `${script};window.digitalData = ${JSON.stringify(initialDataObject)};digitalData.page.attributes.channel = ${setChannelValue};`
}

export function doTrack (event) {
  const waitForSDigitalDataAndTrack = () => {
    if (window.s === undefined) {
      debug(`Trying to fire '${event}'`)
      setTimeout(() => { waitForSDigitalDataAndTrack() }, 500)
    } else {
      debug(`Firing _satellite.track for event '${event}' with payload\n\n`, JSON.stringify(window.digitalData, null, 2))
      window.digitalData.track(event)
    }
  }
  waitForSDigitalDataAndTrack()
}

export function pushEventAndTrack (event, eventName) {
  window.digitalData.event = window.digitalData.event || []

  let events = window.digitalData.event

  events.push(event)
  debug('Pushed event', JSON.stringify(event, null, 2))

  debug(`Firing digitalData.track for event '${eventName || event.eventInfo.eventName}'`)
  window.digitalData.track(eventName || event.eventInfo.eventName)
}

export default updateDigitalData
